import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  useDataPath,
} from '@agilelab/plugin-wb-platform';
import preview from './preview/builder_system_general/builder_system_general.png';
import thumbnail from './preview/builder_system_general/builder_system_general_thumbnail.png';
import { generateEntityFields } from './EntityCustomView';

CustomViewPages.register({
  id: 'builder_system_general',
  meta: {
    label: 'System General Information',
    category: CustomViewPageCategory.BUILDER,
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  function: function DataProductGeneral() {
    const data = useDataPath('');
    // TODO: this needs to be fixed, custom view content should be static and any conditional logic should be implemented using <CustomViewComponent /> attributes such as "showWhen".
    const genFields = generateEntityFields(data);

    return (
      <CustomViewComponent type="catalog_system_card">
        <CustomViewComponent type="container">
          {genFields}
          <CustomViewComponent
            type="hline"
            showWhen={{
              value: '{{ tags.length }}',
              notEquals: 0,
            }}
          />
          <CustomViewComponent
            type="tags"
            label="Tags"
            path="tags"
            showWhen={{
              value: '{{ tags.length }}',
              notEquals: 0,
            }}
          />
        </CustomViewComponent>
      </CustomViewComponent>
    );
  },
});
